//// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
// ( function () {
//    'use strict';
//    jQuery.extend( true, e4.settings, {
//        debug: {
//            show: true,
//            consoleType: 'trace'
//        }
//    } );
// }() );
//

( function () {
    'use strict';
    e4.settings.postfix = '/' + jQuery( '#js-main-container' ).data( 'postfix' );
    jQuery.extend( true, e4.settings, {
        debug: {
            logWebVitals: true
        },
        search: {
            result: {
                pages: {
                    url: e4.settings.postfix + '/system/data/pages?q='
                },
                products: {
                    url: e4.settings.postfix + '/system/data/products?q=',
                    showAllLink: e4.settings.postfix + '/shop/search?q='
                }
            }
        },
        ecom: {
            specifications: {
                url: e4.settings.postfix + '/system/data/specifications'
            },
            filters: {
                url: e4.settings.postfix + '/system/data/products-with-filters'
            },
            cart: {
                url: e4.settings.postfix + '/system/data/cart'
            },
            download: {
                url: e4.settings.postfix + '/system/data/cart-download'
            },
            quickorder: {
                url: e4.settings.postfix + '/system/data/products'
            },
            checkout: {
                url: e4.settings.postfix + '/system/data/checkout'
            }
        },
        dealersearch: {
            url: e4.settings.postfix + '/system/data/dealersearch'
        },
        require: {
            webVitals: {
                url: 'https://unpkg.com/web-vitals',
                fallback: 'https://unpkg.com/web-vitals',
                callback: null
            }
        }
    } );
}() );
